// @mui
import { Container } from '@mui/material';
// components
import { ContactWidget, BenfitWidget } from '../../sections/web/home';
import { AboutWidget } from '../../sections/web/about';
import { Seo } from '../../components/seo';

// ----------------------------------------------------------------------

export default function AboutPage() {
  return (
    <>
      <Seo
        title="About Our Healthcare Licensing Consultancy"
        description="ASAP Marketing and Studies Consultancy is an educational institute specialising in Prometric exam preparation for healthcare professionals across the GCC."
        path="/about-us"
      />

      {/* Each section brings its own spacing and rhythm, so they stack directly
          instead of nesting grid containers. */}
      <Container maxWidth="xl">
        <AboutWidget />
        <BenfitWidget />
        <ContactWidget />
      </Container>
    </>
  );
}
